<template>
  <div class="container">
    <div class="md-layout">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>sports_soccer</md-icon>
          </div>
          <h4 class="title">{{$t('editorial.form.title')}}</h4>
        </md-card-header>

        <md-card-content>
          <!-- Title -->
          <md-field :class="{'md-error': $v.editorialModel.title.$error && $v.editorialModel.title.$invalid, 'md-valid': !$v.editorialModel.title.$error && !$v.editorialModel.title.$invalid}">
            <label>{{$t('editorial.form.titleForm')}}</label>
            <md-input v-model.trim="$v.editorialModel.title.$model"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.editorialModel.title.$error && $v.editorialModel.title.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.editorialModel.title.$error && !$v.editorialModel.title.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field>
          <!-- Description -->
          <md-field :class="{'md-error': $v.editorialModel.description.$error && $v.editorialModel.description.$invalid, 'md-valid': !$v.editorialModel.description.$error && !$v.editorialModel.description.$invalid}">
            <label>{{$t('editorial.form.description')}}</label>
            <md-input v-model.trim="$v.editorialModel.description.$model"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.editorialModel.description.$error && $v.editorialModel.description.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.editorialModel.description.$error && !$v.editorialModel.description.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field>
          <!-- Call To Action Link -->
          <md-field :class="{'md-error': $v.editorialModel.callToActionLink.$error && $v.editorialModel.callToActionLink.$invalid, 'md-valid': !$v.editorialModel.callToActionLink.$error && !$v.editorialModel.callToActionLink.$invalid}">
            <label>{{$t('editorial.form.callToActionLink')}}</label>
            <md-input v-model.trim="$v.editorialModel.callToActionLink.$model"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.editorialModel.callToActionLink.$error && $v.editorialModel.callToActionLink.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.editorialModel.callToActionLink.$error && !$v.editorialModel.callToActionLink.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field>
          <!-- Call To Action Text -->
          <md-field :class="{'md-error': $v.editorialModel.callToActionText.$error && $v.editorialModel.callToActionText.$invalid, 'md-valid': !$v.editorialModel.callToActionText.$error && !$v.editorialModel.callToActionText.$invalid}">
            <label>{{$t('editorial.form.callToActionText')}}</label>
            <md-input v-model.trim="$v.editorialModel.callToActionText.$model"></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="$v.editorialModel.callToActionText.$error && $v.editorialModel.callToActionText.$invalid">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon class="success" v-show="!$v.editorialModel.callToActionText.$error && !$v.editorialModel.callToActionText.$invalid">done</md-icon>
            </slide-y-down-transition>
          </md-field> 
          <!-- Picture  -->
          <md-card class="md-layout-item md-size-30">
            <md-card-header-text>
              <h4 class="title">{{ $t("editorial.form.picture") }}</h4>
            </md-card-header-text>
            <md-card-media-actions>
              <md-card-media class="image-preview">
                <img v-if="$v.editorialModel.picture.$model" :src="getUrlImage($v.editorialModel.picture.$model)" alt="Live preview">
              </md-card-media>

              <md-card-actions>
                <md-button class="md-simple">
                  <label for="upload-picture">
                    <md-file @md-change="uploadPicture" name="upload-picture" id="upload-picture" style="display: none"></md-file>
                    <md-icon>edit</md-icon> Editar
                  </label>
                </md-button>
              </md-card-actions>
            </md-card-media-actions>
          </md-card>
        </md-card-content>
        <!-- PublishDate -->
        <!-- <md-card-content v-if="isEdit">
          <template v-if="!isPublic">
            <md-datepicker v-model="$v.editorialModel.publishDate.$model" md-immediately :class="{'md-error': $v.editorialModel.publishDate.$error && $v.editorialModel.publishDate.$invalid, 'md-valid': !$v.editorialModel.publishDate.$error && !$v.editorialModel.publishDate.$invalid}">
              <label>{{$t('editorial.form.publishDate')}}</label>
            </md-datepicker>
            
            <md-button @click="publish">
              {{$t('editorial.form.publish')}}
            </md-button>
          </template>
          <template v-else>
            <md-button @click="unpublish">
              {{$t('editorial.form.unpublish')}}
            </md-button>
          </template>
        </md-card-content> -->
        <md-card-actions class="actions">
          <md-button @click="sendFormEditorial" class="md-info" :disabled="loading">
            {{isEdit ? $t('editorial.form.edit') : $t('editorial.form.create')}}
          </md-button>

          <template v-if="isEdit">
            <template v-if="!isPublic">
              <md-button class="md-simple md-success" @click="publish">
                {{$t('editorial.form.publish')}}
              </md-button>
            </template>
            <template v-else>
              <md-button class="md-simple md-danger" @click="unpublish">
                {{$t('editorial.form.unpublish')}}
              </md-button>
            </template>
          </template>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import storage from "@/plugins/azure-storage";
import { required } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      classicModal: false,
      editorialModel : {
        publishDate: null,
        title: "",
        description: "",
        picture: "",
        callToActionLink: "",
        callToActionText: ""
      }
    }
  },
  async mounted() {
    this.isEdit = this.$route.params.id != undefined;
    if (this.isEdit) {
      const editorial = await this.$store.dispatch("editorialCardGet", {id: this.$route.params.id})
      this.editorialModel = editorial.data
      this.isPublic = this.editorialModel.publishDate != null
    }
  },
  beforeMount() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy'
  },
  methods: {
    async sendFormEditorial() {
      if (!this.$v.invalid) {
        let model = this.editorialModel
        model.publishDate = `${moment().format('YYYY-MM-DD')}T00:00:00.000`
        if (this.isEdit) model.id = this.$route.params.id
        this.loading = true;
        const response = await this.isEdit ? this.$store.dispatch("editorialCardUpdate", model) : this.$store.dispatch("editorialCardCreate", model)
        if (response != undefined) {
          this.$notify({
            message: this.isEdit ? this.$t(`notifications.editorial.edit`) : this.$t(`notifications.editorial.create`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/editorial")
        } else {
          this.$store.dispatch("openModalError")
        }
        this.loading = false
        return;
      } else {
        return;
      }
    },
    async uploadPicture(FileList) {
      const file = FileList[0];
      this.loading = true;
      const fileName = await storage.updateFile({
        file,
        container: process.env.VUE_APP_CDN_CONTAINER_GAME_PICTURES
      });

      this.editorialModel.picture = fileName;
      this.$v.editorialModel.picture.$touch();
      this.loading = false;

      return;
    },
    getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_GAME_PICTURES}${path}`
    },
    async publish() {
      const params = {
        id: Number(this.$route.params.id),
      }
      const response = await this.$store.dispatch('editorialCardPublish', params)
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.editorial.publish`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push("/list/editorial")
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    async unpublish() {
      const params = {
        id: Number(this.$route.params.id)
      }
      const response = await this.$store.dispatch('editorialCardUnpublish', params)
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.editorial.unpublish`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push("/list/editorial") 
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  },
  validations: {
    editorialModel: {
      publishDate: {
        required
      },
      title: {
        required
      },
      description: {
        required
      },
      picture: {
        required
      },
      callToActionLink: {
        required
      },
      callToActionText: {
        required
      },
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.title {
  margin-top: $margin-base;
}

.actions {
  display: flex;
  justify-content: space-between;
} 

.image-preview {
  background: $gray-lighter;
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: center;
  img {
    object-fit: contain;
  }
}
</style>